import { render, staticRenderFns } from "./IndividualL.vue?vue&type=template&id=352797e7&scoped=true"
import script from "./IndividualL.vue?vue&type=script&lang=js"
export * from "./IndividualL.vue?vue&type=script&lang=js"
import style0 from "./IndividualL.vue?vue&type=style&index=0&id=352797e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352797e7",
  null
  
)

export default component.exports